<template>
  <div class="nav-wrapper">
    <div class="container">
      <LogoTag style="background-color: rgb(0, 37, 60)" class="logo-tag"></LogoTag>
      <div class="home-header-menu">
        <div class="main-menu">
          <div
            v-for="(item, index) in visibleMenuItems"
            :key="index"
            class="menu-item"
            @click="handleSelect(item.path)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="more-menu" v-if="hiddenMenuItems.length > 0">
          <div class="menu-item more" @click="toggleMoreMenu">更多</div>
          <div class="dropdown" :class="{ 'show-dropdown': isMoreMenuOpen }">
            <div
              v-for="(item, index) in hiddenMenuItems"
              :key="index"
              class="dropdown-item"
              @click="handleSelect(item.path)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="search-box">
        <search-box
          :is-ai-mode="isAiMode"
          :placeholder="isAiMode ? '输入问题，AI为你解答' : '搜索内容'"
          :button-text="isAiMode ? '提问' : 'Search'"
          :is-loading="isLoading"
          :preview-content="previewContent"
          :is-preview-visible="isPreviewVisible"
          @toggle-ai="toggleAiMode"
          @search="handleSearch"
        ></search-box>
      </div>
    </div>
    <div class="mobile-menu-wrap">
      <div class="mobile-menu-panel" :class="{ 'panel-open': isMobileMenuOpen }" @click.stop>
        <div class="panel-header-bg"></div>
        <div class="panel-header-divider"></div>
        <button class="panel-btn home-btn" @click="handleMobileSelect('/home')">
          <span class="home-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 12L12 3L21 12V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V12Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 22V12H15V22"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>
        <button class="panel-btn scroll-top-btn" @click="scrollToTop">
          <span class="scroll-top-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 19V5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 12L12 5L19 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>
        <button class="panel-btn close-btn" @click="toggleMobileMenu">
          <span class="menu-icon" :class="{ 'icon-close': isMobileMenuOpen }"></span>
        </button>
        <div class="panel-menu">
          <div
            v-for="(item, index) in menuItems.slice(1)"
            :key="index"
            class="panel-item"
            @click="handleMobileSelect(item.path)"
          >
            <span class="panel-item-text">{{ item.label }}</span>
            <span class="panel-item-arrow">›</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LogoTag } from './components'
import { SearchBox } from '@/components'

export default {
  name: 'NavBar',
  components: { LogoTag, SearchBox },
  data() {
    return {
      isMoreMenuOpen: false,
      isMobileMenuOpen: false,
      isAiMode: true,
      isLoading: false,
      previewContent: '',
      isPreviewVisible: false,
      menuItems: [
        { label: '主页', path: '/home' },
        { label: '我的简历', path: '/resume' },
        { label: '微微细语', path: '/communication' },
        { label: '优雅代码', path: '/code' }
      ],
      visibleMenuItems: [],
      hiddenMenuItems: [],
      currentXhr: null,
      conversationId: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateMenuItems()
    })
    window.addEventListener('resize', this.updateMenuItems)
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMenuItems)
    document.removeEventListener('click', this.handleOutsideClick)
    this.cancelRequest()
  },
  methods: {
    toggleMoreMenu() {
      this.isMoreMenuOpen = !this.isMoreMenuOpen
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleOutsideClick(e) {
      if (
        this.isMobileMenuOpen &&
        !this.$el.querySelector('.mobile-menu-wrap')?.contains(e.target)
      ) {
        this.isMobileMenuOpen = false
      }
    },
    handleSelect(path) {
      const resolved = this.$router.resolve(path)
      if (this.$route.fullPath !== resolved.route.fullPath) {
        this.$router.push(path)
      } else {
        this.$router.go(0)
        window.scrollTo(0, 0)
      }
    },
    handleMobileSelect(path) {
      this.isMobileMenuOpen = false
      setTimeout(() => {
        this.handleSelect(path)
      }, 300)
    },
    updateMenuItems() {
      const chatAiBoxWidth = document.querySelector('.chat-ai-box')?.offsetWidth || 0
      const searchBoxWidth = document.querySelector('.search-box')?.offsetWidth || 0
      const switchBoxWidth = document.querySelector('.switch-box')?.offsetWidth || 0
      const logoTagWidth = document.querySelector('.logo-tag').offsetWidth
      const fatherWidth = document.querySelector('.container').offsetWidth
      const leftWidth =
        fatherWidth - chatAiBoxWidth - searchBoxWidth - switchBoxWidth - logoTagWidth
      let totalWidth = 0
      this.visibleMenuItems = []
      this.hiddenMenuItems = []
      for (const item of this.menuItems) {
        const itemWidth = 15 * 2 + item.label.length * 16
        if (totalWidth + itemWidth <= leftWidth - 62) {
          this.visibleMenuItems.push(item)
          totalWidth += itemWidth
        } else {
          this.hiddenMenuItems.push(item)
        }
      }
    },
    toggleAiMode() {
      this.isAiMode = !this.isAiMode
      this.resetPreview()
      if (this.isAiMode) {
        this.$nextTick(() => {
          this.$el.querySelector('.ai-input')?.focus()
        })
      }
    },
    resetPreview() {
      this.isPreviewVisible = false
      this.previewContent = ''
    },
    cancelRequest() {
      if (this.currentXhr) {
        this.currentXhr.abort()
        this.currentXhr = null
      }
    },
    handleSearch(keyword) {
      const kw = keyword.trim()
      if (!kw) {
        return alert('请输入内容')
      }

      // 取消之前的请求
      this.cancelRequest()

      this.isLoading = true
      this.isPreviewVisible = true

      if (this.isAiMode) {
        // AI 模式：调用 SSE 接口
        this.previewContent = `AI正在思考关于"${kw}"的问题...`
        this.callDifySSE(kw)
      } else {
        // 搜索模式：模拟搜索
        this.previewContent = `搜索结果：正在搜索"${kw}"...`
        setTimeout(() => {
          this.isLoading = false
          this.previewContent = `搜索结果：找到 128 条与"${kw}"相关的内容`
        }, 1500)
      }
    },
    callDifySSE(query) {
      const url = 'http://117.72.101.203:9090/web/client/dify/chat-messages'
      const payload = {
        query,
        inputs: {},
        response_mode: 'streaming',
        user: 'web-user'
      }
      if (this.conversationId) {
        payload.conversation_id = this.conversationId
      }

      const xhr = new XMLHttpRequest()
      this.currentXhr = xhr

      xhr.open('POST', url, true)
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.setRequestHeader('Accept', 'text/event-stream')

      let processedLength = 0
      let answerText = ''

      xhr.onprogress = () => {
        const fullText = xhr.responseText
        const newText = fullText.substring(processedLength)
        const lines = newText.split('\n')
        const completeEvents = []
        let eventName = 'message'
        let dataParts = []

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i]
          // 如果是最后一行，它可能还不完整，留到下次处理
          if (i === lines.length - 1) {
            break
          }
          if (line === '') {
            if (dataParts.length > 0) {
              completeEvents.push({ event: eventName, data: dataParts.join('') })
              dataParts = []
            }
            eventName = 'message'
          } else if (line.startsWith('event:')) {
            eventName = line.substring(6).trim() || 'message'
          } else if (line.startsWith('data:')) {
            dataParts.push(line.substring(5))
          }
          processedLength += line.length + 1
        }

        for (const evt of completeEvents) {
          if (evt.data === '[DONE]') continue
          if (evt.event === 'message') {
            try {
              const parsed = JSON.parse(evt.data)
              if (parsed.answer) {
                answerText += parsed.answer
                this.previewContent = `AI回答：${answerText}`
              }
              if (parsed.conversation_id) {
                this.conversationId = parsed.conversation_id
              }
            } catch (e) {
              // ignore
            }
          } else if (evt.event === 'workflow_finished') {
            this.isLoading = false
          }
        }
      }

      xhr.onload = () => {
        this.isLoading = false
        if (xhr.status !== 200) {
          console.error('SSE请求失败:', xhr.status, xhr.statusText)
          this.previewContent = `AI回答：抱歉，发生了一些错误，请稍后重试。`
        }
        this.currentXhr = null
      }

      xhr.onerror = () => {
        this.isLoading = false
        console.error('SSE请求错误')
        this.previewContent = `AI回答：网络错误，请稍后重试。`
        this.currentXhr = null
      }

      xhr.send(JSON.stringify(payload))
    }
  }
}
</script>

<style scoped>
@import './css/variables.css';

.nav-wrapper {
  position: relative;
  width: 100%;
}

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial,
    sans-serif;
  /* 禁止选中菜单文字 */
  user-select: none;
  -webkit-user-select: none;
}

.logo-tag {
  flex-shrink: 0;
}

.search-box {
  padding: 1px;
  flex-shrink: 0;
}

.home-header-menu {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}

.main-menu {
  display: flex;
}

/* ====================== 菜单核心悬浮特效（主题色 #7058e0） ====================== */
.menu-item {
  padding: 0 18px;
  height: var(--nav-height);
  line-height: var(--nav-height);
  color: #c3b8ff; /* 柔和科技紫 */
  cursor: pointer;
  transition: all 0.28s ease;
  position: relative;
  font-weight: 500;
  -webkit-tap-highlight-color: transparent;
}

/* 悬浮效果：高亮文字 + 发光背景 + 主题色 */
.menu-item:hover {
  color: #ffffff;
  background-color: #7058e0;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.3);
}

/* 更多菜单按钮同风格 */
.menu-item.more {
  color: #c3b8ff;
}
.menu-item.more:hover {
  color: #fff;
  background-color: #7058e0;
}

/* ====================== 下拉菜单美化（统一主题） ====================== */
.more-menu {
  position: relative;
}

.dropdown {
  display: none;
  position: absolute;
  top: calc(var(--nav-height) + 4px);
  right: 0;
  min-width: 150px;
  background-color: #1a1635;
  border: 1px solid #7058e0;
  box-shadow: 0 6px 20px rgba(112, 88, 224, 0.25);
  z-index: 999;
  border-radius: 8px;
  overflow: hidden;
}

.show-dropdown {
  display: block;
}

.dropdown-item {
  padding: 11px 18px;
  color: #e0e0ff;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.dropdown-item:hover {
  background-color: #7058e0;
  color: #ffffff;
  padding-left: 22px;
}

.mobile-menu-btn {
  display: none;
  position: fixed;
  top: 40%;
  right: 0;
  width: 44px;
  height: 44px;
  border: none;
  background: rgba(112, 88, 224, 0.6);
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 999;
  backdrop-filter: blur(6px);
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  -webkit-tap-highlight-color: transparent;
}

.mobile-menu-btn:hover {
  background: rgba(112, 88, 224, 0.8);
  width: 48px;
}

.menu-icon {
  display: block;
  width: 20px;
  height: 3px;
  background: #c3b8ff;
  position: relative;
  border-radius: 2px;
}

.menu-icon::before,
.menu-icon::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 3px;
  background: #c3b8ff;
  border-radius: 2px;
  left: 0;
}

.menu-icon::before {
  top: -6px;
}

.menu-icon::after {
  top: 6px;
}

.menu-icon.icon-close::before {
  top: 0;
  transform: rotate(45deg);
}

.menu-icon.icon-close::after {
  top: 0;
  transform: rotate(-45deg);
}

.menu-icon.icon-close {
  background: transparent;
}

.mobile-menu-wrap {
  position: fixed;
  top: 40%;
  right: 0;
  z-index: 999;
  display: none;
}

.mobile-menu-panel {
  position: relative;
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, rgba(30, 40, 60, 0.95) 0%, rgba(20, 28, 44, 0.98) 100%);
  border-radius: 6px 0 0 6px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.2);
  transform: scale(1);
  transform-origin: right center;
  transition: width 0.35s cubic-bezier(0.32, 0.72, 0, 1),
    height 0.35s cubic-bezier(0.32, 0.72, 0, 1), background 0.25s ease, border-radius 0.25s ease,
    box-shadow 0.25s ease, border 0.25s ease;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(112, 88, 224, 0.25);
  -webkit-tap-highlight-color: transparent;
}

.panel-open {
  width: 170px;
  height: auto;
  background: linear-gradient(135deg, rgba(30, 40, 60, 0.95) 0%, rgba(20, 28, 44, 0.98) 100%);
  border-radius: 14px;
  box-shadow: -8px 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(112, 88, 224, 0.25);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.panel-open .panel-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  background: linear-gradient(180deg, rgba(112, 88, 224, 0.12) 0%, rgba(112, 88, 224, 0.02) 100%);
  pointer-events: none;
  z-index: 0;
  border-top-left-radius: 14px;
  border-top-right-radius: 48px;
}

.panel-open .panel-header-divider {
  position: absolute;
  top: 44px;
  left: 14px;
  right: 14px;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(112, 88, 224, 0.25) 30%,
    rgba(112, 88, 224, 0.25) 70%,
    transparent 100%
  );
  pointer-events: none;
  z-index: 1;
}

.panel-btn {
  width: 25px;
  height: 20px;
  border: none;
  background: transparent;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  transition: all 0.3s cubic-bezier(0.32, 0.72, 0, 1);
  -webkit-tap-highlight-color: transparent;
}

.panel-open .panel-btn {
  width: 28px;
  height: 28px;
  top: 8px;
  transform: translateY(0);
  background: rgba(112, 88, 224, 0.15);
  border: 1px solid rgba(112, 88, 224, 0.2);
  border-radius: 8px;
}

.panel-open .home-btn {
  left: 50%;
  transform: translate(-50%, 0);
}

.panel-open .close-btn {
  left: auto;
  right: 14px;
  transform: translateY(0);
}

.panel-open .panel-btn:hover {
  background: rgba(112, 88, 224, 0.3);
  border-color: rgba(112, 88, 224, 0.4);
}

.home-btn,
.scroll-top-btn {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.panel-open .home-btn,
.panel-open .scroll-top-btn {
  opacity: 1;
  pointer-events: auto;
}

.panel-open .scroll-top-btn {
  left: 14px;
  transform: translateY(0);
}

.scroll-top-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c3b8ff;
}

.scroll-top-icon svg {
  width: 100%;
  height: 100%;
}

.panel-btn .menu-icon {
  width: 14px;
  height: 2px;
  position: relative;
  display: block;
  transition: all 0.3s ease;
}

.panel-btn .menu-icon::before,
.panel-btn .menu-icon::after {
  width: 14px;
  height: 2px;
  left: 0;
  transition: all 0.3s ease;
}

.panel-btn .menu-icon::before {
  top: -4px;
}

.panel-btn .menu-icon::after {
  top: 4px;
}

.panel-open .panel-btn .menu-icon {
  width: 12px;
  height: 2px;
}

.panel-open .panel-btn .menu-icon::before,
.panel-open .panel-btn .menu-icon::after {
  width: 12px;
  height: 2px;
}

.panel-open .panel-btn .menu-icon::before {
  top: 0;
}

.panel-open .panel-btn .menu-icon::after {
  top: 0;
}

.panel-menu {
  padding: 44px 12px 8px;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.25s cubic-bezier(0.32, 0.72, 0, 1);
  transition-delay: 0s;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.panel-open .panel-menu {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 0.12s;
  pointer-events: auto;
}

.panel-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 14px;
  color: #e8e8ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 10px;
  margin-bottom: 2px;
  height: 30px;
  box-sizing: border-box;
  margin-left: 8px;
  margin-right: 8px;
  -webkit-tap-highlight-color: transparent;
}

.panel-item:last-child {
  margin-bottom: 0;
}

.panel-item:hover,
.panel-item:active {
  background: rgba(112, 88, 224, 0.2);
  color: #ffffff;
}

.panel-item-text {
  flex: 1;
}

.panel-item-arrow {
  font-size: 16px;
  color: #7058e0;
  opacity: 0.6;
  transition: all 0.2s ease;
}

.panel-item:hover .panel-item-arrow,
.panel-item:active .panel-item-arrow {
  opacity: 1;
  transform: translateX(-2px);
}

.home-btn .home-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c3b8ff;
}

.home-btn .home-icon svg {
  width: 100%;
  height: 100%;
}

@media (max-width: 1024px) {
  .container {
    padding: 0 20px;
  }

  .menu-item {
    padding: 0 14px;
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .container {
    justify-content: flex-start;
    padding: 0 16px 0 0;
    gap: 0;
  }

  .logo-tag {
    flex-shrink: 0;
  }

  .home-header-menu {
    flex: 1;
    justify-content: center;
    display: flex;
  }

  .search-box {
    margin-left: 0;
    flex-shrink: 1;
    min-width: 0;
  }

  .menu-item {
    padding: 0 10px;
    font-size: 13px;
  }

  .mobile-menu-wrap {
    display: none;
  }
}

@media (max-width: 460px) {
  .container {
    padding: 0 10px 0 5px;
    gap: 0px;
    justify-content: flex-start;
  }

  .home-header-menu {
    display: none;
  }

  .logo-tag {
    flex-shrink: 0;
  }

  .search-box {
    flex: 1;
    min-width: 0;
    margin-left: 0;
  }

  .mobile-menu-wrap {
    display: block;
  }
}
</style>
